<template>
  <div class="ai-agent-actions-panel">
    <!-- Loading Spinner -->
    <div class="centerblockimg" v-if="isLoading">
      <Spin size="large" />
      <div class="mt-10">Loading AI Agent Actions...</div>
    </div>

    <!-- Empty State -->
    <div class="centerblockimg" v-else-if="!aiAgentActions || aiAgentActions.length === 0">
      <svgicon name="empty-timeline" width="180" height="130" :original="true"/>
      <div class="mt-10">{{ $t('AI_AGENT_NO_ACTIONS_FOUND') }}</div>
    </div>

    <!-- Actions List -->
    <div class="ai-agent-body" v-else>
      <AIAgentActionCard
        v-for="(action, index) in aiAgentActions"
        :key="action._id || 'action-' + index"
        :action="action"
        :isInvoice="isInvoice"
        :timeFormat="timeFormat"
      />
    </div>
  </div>
</template>

<script>
import AIAgentActionCard from './AIAgentActionCard';

export default {
  name: 'AIAgentActions',
  components: {
    AIAgentActionCard,
  },
  props: {
    orderId: {
      type: [String, Number],
      default: null,
    },
    invoiceId: {
      type: [String, Number],
      default: null,
    },
    isInvoice: {
      type: Boolean,
      default: false,
    },
    timeFormat: {
      type: String,
      default: 'DD MMM YYYY, hh:mm A',
    },
    actions: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      aiAgentActions: [],
      isLoading: false,
    };
  },
  mounted() {
    if (Array.isArray(this.actions)) {
      // Parent supplied the actions — render directly, no fetch needed.
      this.aiAgentActions = this.actions;
      this.$emit('actionsLoaded', this.aiAgentActions.length);
    } else {
      this.loadAIAgentActions();
    }
  },
  methods: {
    async loadAIAgentActions() {
      this.isLoading = true;

      try {
        let result;

        // Determine which store module to use based on context
        if (this.isInvoice && this.$store.hasModule && this.$store.hasModule(['paymentsV2'])) {
          // Transporter invoice context
          result = await this.$store.dispatch('paymentsV2/fetchAIAgentActions', {
            invoiceId: this.invoiceId,
          });
        } else {
          // Shipper order/invoice context
          result = await this.$store.dispatch('order/fetchAIAgentActions', {
            orderId: this.isInvoice ? this.invoiceId : this.orderId,
          });
        }

        if (result && Array.isArray(result)) {
          this.aiAgentActions = result;
        } else {
          this.aiAgentActions = [];
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('AI_AGENT_ACTIONS_LOAD_FAILURE') });
        this.aiAgentActions = [];
      } finally {
        this.isLoading = false;
        this.$emit('actionsLoaded', this.aiAgentActions.length);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ai-agent-actions-panel {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  border-radius: 5px;
}

.centerblockimg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #8c8c8c;
}
</style>
